




































































import { UserPatch } from "@infoland/iprova-api";
import storeHelper from "@/store/store-helper";
import Utils from "@/utils";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import { SnackBarTimeout } from "@/enums";
import { OutOfOfficeDto } from "@/api/OutOfOfficeDto";
import InfolandDatePicker from "@/components/generic/infoland-date-picker.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "OutOfOfficeContent",
    props: { languageCode: String },
    components: { InfolandDatePicker },
    data: () => {
        return {
            outOfOfficeStart: false,
            outOfOfficeEnd: false,
            endDate: null,
            startDate: null,
            outOfOffice: null as OutOfOfficeDto,
            outOfOfficeState: null as Boolean
        };
    },
    computed: {
        formattedStartDate(): string {
            return this.startDate ? Utils.formatDate(new Date(this.startDate), storeHelper.userStore.loggedOnUser?.date_format) : null;
        },
        formattedEndDate(): string {
            return this.endDate ? Utils.formatDate(new Date(this.endDate), storeHelper.userStore.loggedOnUser?.date_format) : null;
        }
    },
    methods: {
        async saveOutOfOffice(): Promise<boolean> {
            const loggedOnUser = storeHelper.userStore.loggedOnUser;
            if (this.outOfOfficeState) {
                const user = {
                    out_of_office: null
                };
                const result = await storeHelper.userStore.saveUserAsync(loggedOnUser.user_id, user as UserPatch);
                if (result) {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("settings.messages.setOutOfOfficeOff").toString(), false, SnackBarTimeout.short);
                    this.startDate = null;
                    this.endDate = null;
                    this.outOfOffice = null;
                    this.$emit("close-out-of-office");
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            } else {
                const user = {
                    out_of_office: {
                        from: new Date(this.startDate).toAPIDateString(),
                        to: this.endDate ? new Date(this.endDate).toAPIDateString() : null
                    }
                };
                const result = await storeHelper.userStore.saveUserAsync(loggedOnUser.user_id, user as UserPatch);
                if (result) {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("settings.messages.setOutOfOfficeOn").toString(), false, SnackBarTimeout.short);
                    this.$emit("close-out-of-office");
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            }
            return true;
        }
    },
    created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.saveOutOfOffice });
        this.outOfOffice = storeHelper.userStore.loggedOnUser?.out_of_office;
        this.outOfOfficeState = this.outOfOffice !== undefined;
        if (this.outOfOffice) {
            if (this.outOfOffice.from) {
                this.startDate = this.outOfOffice.from.toDate();
            }

            if (this.outOfOffice.to) {
                this.endDate = this.outOfOffice.to.toDate();
            }
        } else {
            this.startDate = new Date().toISOString().slice(0, 10);
        }
    }
});
